export default __webpack_public_path__ + "static/media/fingerPoint.c78b4d61.png";